import React, {useState} from "react";
import {cancelMergeProcess, getStationProjects} from "../../api/MergeUnMerge";
import {confirmAlert} from "react-confirm-alert";
import Alert from "../Alert";
import MergeDialog from "./MergeDialog";
import UnMergeDialog from "./UnMergeDialog";
import {projectStatusMap} from "../ProjectStatusMap";
import Button from "../Button";
import SpinnerNew from "../Spinner/SpinnerNew";

function MergeUnMergeProcess({ project, history}) {

    const [spinnerOn, setSpinnerOn] = useState(false);

    async function openMergeDialog() {
        setSpinnerOn(true);
        let response = await getStationProjects(project.stationName);
        setSpinnerOn(false);
        let projectList =  [];
        for(var i=0; i<response.data.length;++i)
        {
           if(response.data[i].id !== project.id)
               projectList.push({...response.data[i], 'invalid': false, 'selected':false});
           else
               projectList.unshift({...response.data[i], 'invalid': false, 'selected':true});
        }
        if(projectList && projectList.length < 2)
        {
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <div className="react-confirm-alert-body">
                            <h4>{'Merge Additional'}</h4>
                            <p> {'There are no projects available to Merge.'}</p>
                            <br/>
                            <div className="btn ok-2">
                                <Button
                                    className="btn btn-primary start-5"
                                    onClickHandler={onClose}
                                > Ok </Button>
                            </div>
                        </div>
                    );
                }
            });
            return;
        }

        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,

            customUI: ({ onClose }) => {
                return (
                    <MergeDialog project={project} projectList={projectList} onClose={onClose}
                                 onMergeCancel={onMergeCancel} onMergeComplete={onMergeComplete}/>
                );
            }
        });

    }

    async function onMergeComplete(p)
    {
        //let p = await getProject(id);
        let status = projectStatusMap[p.projectStatus];
        history.replace('/dashboard/'+status);
        history.replace(`/${status}/${p.id}/overview`);
    }

    async function onMergeCancel(runId)
    {
        setSpinnerOn(true);
        let response = await cancelMergeProcess(runId);
        setSpinnerOn(false);
    }

    ///////////    UNMERGE        //////////////////////
    function openUnMergeDialog() {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <UnMergeDialog project={project} onUnMerge={onUnMerge} onClose={onClose}/>
                );
            }
        });
    }

    async function onUnMerge(unMergeReponse)
    {
        if(unMergeReponse && unMergeReponse.status==='FAILURE')
        {
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <Alert msg={'Unknown error - Please contact support.'} onClose={onClose}/>
                    );
                }
            });
        }
        else if(unMergeReponse.data &&  unMergeReponse.data.status === 'FAILED')
        {
            //alert(unMergeReponse.data.processMsg);
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <Alert msg={unMergeReponse.data.processMsg} onClose={onClose}/>
                    );
                }
            });
        }
        else
        {
            history.push('/dashboard/'+projectStatusMap[project.projectStatus]);
        }
    }

    return(
        <div>
            <SpinnerNew display={spinnerOn}/>
            <button
                className="btn btn-primary start-5"
                disabled={spinnerOn}
                onClick={async () => {
                    await openMergeDialog();
                }}>
                {"  "}
                Merge
            </button>
            {project.relatedProjects.length > 0 &&
            <button
                className="btn btn-primary start-5"
                disabled={spinnerOn}
                onClick={async () => {
                    openUnMergeDialog();
                }}>
                {"  "}
                UnMerge
            </button>
            }
        </div>
    )
}

export default MergeUnMergeProcess;
